exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".no-products .base-input input[name=\"no-product-select\"] {\n  font-size: 15px;\n  cursor: pointer;\n}\n", ""]);

// exports
